import { render, staticRenderFns } from "./InviteModal.vue?vue&type=template&id=264e9893&scoped=true&"
import script from "./InviteModal.vue?vue&type=script&lang=js&"
export * from "./InviteModal.vue?vue&type=script&lang=js&"
import style0 from "./InviteModal.scss?vue&type=style&index=0&id=264e9893&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "264e9893",
  null
  
)

export default component.exports